module.exports = __webpack_public_path__ + "static/media/ethos-engineering.33258bfc.jpg";